import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-building-line text-xl text-primary-400"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50">
                  琉璃神社
                </span>
              </Link>
              <p className="text-background-400 text-sm leading-relaxed">
                官方正版资源与最新公告平台。为粉丝与创作者提供权威信息、独家内容与官方授权素材。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4">内容分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-background-400 hover:text-primary-400 text-sm transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-background-400 hover:text-primary-400 text-sm transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-background-400 hover:text-primary-400 text-sm transition-colors">
                    加入我们
                  </a>
                </li>
                <li>
                  <a href="#" className="text-background-400 hover:text-primary-400 text-sm transition-colors">
                    商务合作
                  </a>
                </li>
                <li>
                  <a href="#" className="text-background-400 hover:text-primary-400 text-sm transition-colors">
                    用户协议
                  </a>
                </li>
                <li>
                  <a href="#" className="text-background-400 hover:text-primary-400 text-sm transition-colors">
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4">联系方式</h4>
              <ul className="space-y-3 text-background-400 text-sm">
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                    <i className="ri-mail-line text-xs"></i>
                  </div>
                  <span>contact@liulishenshe.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                    <i className="ri-customer-service-line text-xs"></i>
                  </div>
                  <span>在线客服：工作日 9:00-18:00</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                    <i className="ri-map-pin-line text-xs"></i>
                  </div>
                  <span>上海市浦东新区张江高科技园区</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-500 text-sm">
              &copy; 2026 琉璃神社官方 版权所有
            </p>
            <p className="text-background-500 text-sm">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-background-400 transition-colors">
                沪ICP备2026XXXXXXXX号
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}